import React from 'react';
import { Spinner } from 'react-bootstrap';
import './styles.css';

interface PropsType {}

const Loader: React.FC<PropsType> = () => (
  <>
    <div className='loader w-100 d-flex justify-content-center align-items-center'>
      <Spinner animation='border' variant='primary' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </Spinner>
      <p className='text-center text-white'>
        This may take a few seconds, please don&apos;t close this page.
      </p>
    </div>
  </>
);

export default Loader;
